export function cigarettes(value) {
	if (value === 0) return 'Niet gemeten';
	if (value === 1) return 'Geen';
	if (value < 10) return '< 10 stuks';
	if (value > 10) return '> 10 stuks';
}

export default { cigarettes };
